import { render, staticRenderFns } from "./AddressView.vue?vue&type=template&id=3116bce6&scoped=true&"
import script from "./AddressView.vue?vue&type=script&lang=js&"
export * from "./AddressView.vue?vue&type=script&lang=js&"
import style0 from "./AddressView.vue?vue&type=style&index=0&id=3116bce6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3116bce6",
  null
  
)

export default component.exports